import PlayerBasicModel from "../../../Football/Models/Player/PlayerShortModel";

export default class MatchPlayerMarketResultModel {
  public playerId: string = null;
  public playerModel: PlayerBasicModel = null;
}
